<span class="font-5 d-flex align-items-center clip3 position-relative me-2 user-card fw-normal primary-text-100 primary-border corner p-2">
    <ng-content select="[button-1]"></ng-content>
    <span class="mx-2 divider"></span>

    <ng-content select="[button-2]"></ng-content>

    <span class="mx-2 divider"></span>
    <ng-content select="[button-3]"></ng-content>
</span>
